import { Animate, AuthContext, Card, Form, Link, Row } from "components/lib";
import { useContext } from "react";
import logo from "./images/black_logo.png";
import truck_image from "./images/truck.png";
import styles from "./styles.module.scss";

export function SignupUser(props) {
  const context = useContext(AuthContext);
  const url = window.location.href;
  const email = url.substring(url.indexOf("&email") + 7);

  return (
    <Animate type="pop">
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.header}>
            <img
              src={logo}
              alt="Logo"
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.location.href = "https://coverbadger.com";
              }}
            />
          </div>
          <div className={styles.wrapper}>
            <Row title="Create your account">
              <div className={styles.desc}>
                Enter your credentials to access your account
              </div>
              <Card restrictWidth center>
                <Card restrictWidth center>
                  <Form
                    inputs={{
                      name: {
                        label: "First Name",
                        value: "",
                        type: "text",
                        required: true,
                        errorMessage: "Please enter your first name",
                      },
                      email: {
                        label: "Email",
                        value: email,
                        type: "email",
                        required: true,
                      },
                      password: {
                        label: "Password",
                        type: "password",
                        required: true,
                        complexPassword: true,
                      },
                      confirm_password: {
                        type: "hidden",
                        value: null,
                      },
                      /*     invite_id: {
                        type: "hidden",
                        value: id,
                      }, */
                    }}
                    url="/api/user"
                    method="POST"
                    redirect="/app/dashboard"
                    buttonText="Create Account"
                    callback={context.signin}
                  />

                  <div className="mt-4">
                    Already registered?{" "}
                    <Link url="/app/" text="Sign In" />
                  </div>
                </Card>
              </Card>
            </Row>
          </div>
          <div className={styles.footer}>Coverbadger ©2025</div>
        </div>
        <div
          className={styles.right}
          style={{ backgroundImage: "url(" + truck_image + ")" }}
        />
      </div>
    </Animate>
  );
}
